import { ChangeDetails } from "../../utils/reviewWorkflow";
import { getToken } from "../storage/authStorage";
import { API_BASE_URL } from "../../../config/api";

class APIError extends Error {
  public status: number;
  public data: any;

  constructor(message: string, status: number, data: any = null) {
    super(message);
    this.name = "APIError";
    this.status = status;
    this.data = data;
  }
}

const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};

/**
 * Review Request DTO from API
 */
export interface ReviewRequestDTO {
  id: number;
  user_id: number;
  reviewer_id?: number;
  module_code: string;
  module_name: string;
  action_code: string;
  action_name: string;
  entity_type: string;
  entity_id: number;
  status: "pending" | "approved" | "rejected";
  request_comments?: string;
  review_comments?: string;
  reviewed_at?: string;
  is_applied?: boolean;
  created_at: string;
  requester_name?: string;
  requester_email?: string;
  reviewer_name?: string;
  reviewer_email?: string;
  reviewer_role?: string;
  // change_details?: {
  //   old_value?: string;
  //   new_value?: string;
  //   reason?: string;
  //   field_changes?: Array<{
  //     field: string;
  //     old: string;
  //     new: string;
  //   }>;
  // };
  change_details?: ChangeDetails;
}

/**
 * Get Review by Entity Response DTO
 */
export interface GetReviewByEntityResponseDTO {
  success: boolean;
  data: {
    review: ReviewRequestDTO | null;
  };
  message: string;
}

/**
 * Get review by entity
 * GET /api/reviews/by-entity?entity_type={type}&entity_id={id}
 */
export const getReviewByEntity = async (
  entityType: string,
  entityId: number
): Promise<GetReviewByEntityResponseDTO> => {
  const token = getToken();
  if (!token) {
    throw new APIError(
      "No authentication token found",
      HTTP_STATUS.UNAUTHORIZED
    );
  }

  const queryParams = new URLSearchParams({
    entity_type: entityType,
    entity_id: entityId.toString(),
  });

  const url = `${API_BASE_URL}/api/reviews/by-entity?${queryParams.toString()}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new APIError(
        errorData.message || `HTTP error! status: ${response.status}`,
        response.status,
        errorData
      );
    }

    return await response.json();
  } catch (error) {
    if (error instanceof APIError) {
      throw error;
    }
    throw new APIError(
      `Network error: ${
        error instanceof Error ? error.message : "Unknown error"
      }`,
      HTTP_STATUS.INTERNAL_SERVER_ERROR
    );
  }
};
